import React from "react";
import { useEffect } from "react";
import Show from "../../utils/show.component";
import moment from "moment";
import { formatDate, usd } from "../../utils/utils";
import { payoffCompleteHeader } from "../../utils/content";
import { DisplayRow } from "../../utils/displayRow.component";

const PaymentReceipt = (props) => {
  const parsedAmount = parseFloat(props.PaymentAmount);
  const parsedConvenienceFee = props.FeeAmount ? parseFloat(props.FeeAmount) : 0;
  const total = parsedAmount + parsedConvenienceFee;

  const formattedDate = props.PostDate
    ? moment(props.PostDate.split("T")[0]).format("MM/DD/YYYY")
    : "";

  const standardOrFeeType = props.feeType ? "Fee Payment" : "Regular Payment";

  let paymentDetails = () => {
    if (props.paymentType === "debit" || props.paymentType === "Appraisal") {
      return `${props.CardType} ${props.CardNumberLastFour}`;
    } else {
      return `Account ending in ${props.CardNumberLastFour}`;
    }
  };

  useEffect(() => {
    if (props.payoffCheck.PaymentTypeChangedToPayoff === true) {
      props.modifyHeader(payoffCompleteHeader.header, payoffCompleteHeader.description);
    }
  }, []);

  return (
    <div data-e2e-id="paymentRecieptPage">
      <div className="loan-details-container payment-receipt container">
        <div className="confirmation-number">
          <DisplayRow label={`Confirmation #: ${props.confirmationNumber}`} />
        </div>
        <DisplayRow
          label="Online Payment"
          value={moment().format("MM/DD/YYYY hh:mm A")}
          rowClasses="bold mt-4"
        />
        <hr />
        <Show condition={props.feeType}>
          <DisplayRow label={props.feeType} rowClasses="bold f18" />
          <hr />
        </Show>
        <Show condition={props.description && props.LoanNumberLastFour}>
          <DisplayRow
            condition={props.description && props.LoanNumberLastFour}
            label={`${props.description} ${props.LoanNumberLastFour}`}
            rowClasses="bold f18"
          />
          <hr />
        </Show>
        <DisplayRow label={standardOrFeeType} value={props.NameOnCard} rowClasses="bold" />
        <Show condition={!props.feeType}>
          <DisplayRow label="Effective Date" value={formattedDate} rowClasses="mt-2" />
        </Show>
        <DisplayRow label="Payment Account" value={paymentDetails()} rowClasses="mt-2" />
        <DisplayRow label="Payment Amount" value={usd.format(parsedAmount)} rowClasses="mt-2" />
        <Show condition={parsedConvenienceFee}>
          <DisplayRow
            label="Convenience Fee"
            value={usd.format(parsedConvenienceFee)}
            rowClasses="mt-2"
          />
        </Show>
        <hr />
        <DisplayRow label="Total Payment" value={usd.format(total)} rowClasses="bold pb-4 f18" />
      </div>
    </div>
  );
};

export default PaymentReceipt;



// WEBPACK FOOTER //
// ./src/components/payment-receipt/payment-receipt.component.js